import { TFunction } from 'i18next'
import { Color } from '@/components/GokuDataGrid/CellStatus'

export const RESELLER_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    SUSPENDED: 'suspended',
} as const

export const RESELLER_TIERS = {
    BRONZE: 'bronze',
    SILVER: 'silver',
    GOLD: 'gold',
    PLATINUM: 'platinum',
} as const

export const RESELLER_STATUS_OPTIONS = (t: TFunction) => [
    {
        label: t('active'),
        value: RESELLER_STATUS.ACTIVE,
        color: 'success' as Color,
    },
    {
        label: t('inactive'),
        value: RESELLER_STATUS.INACTIVE,
        color: 'default' as Color,
    },
    {
        label: t('suspended'),
        value: RESELLER_STATUS.SUSPENDED,
        color: 'error' as Color,
    },
]

export const RESELLER_TIER_OPTIONS = (t: TFunction) => [
    {
        label: t('bronze'),
        value: RESELLER_TIERS.BRONZE,
        color: 'default' as Color,
    },
    {
        label: t('silver'),
        value: RESELLER_TIERS.SILVER,
        color: 'secondary' as Color,
    },
    {
        label: t('gold'),
        value: RESELLER_TIERS.GOLD,
        color: 'warning' as Color,
    },
    {
        label: t('platinum'),
        value: RESELLER_TIERS.PLATINUM,
        color: 'info' as Color,
    },
]

// Keep old function names for backward compatibility (with color for CellStatus)
export const getResellerStatusOptions = RESELLER_STATUS_OPTIONS
export const getResellerTierOptions = RESELLER_TIER_OPTIONS

// Filter options without color property (for FormItem select)
export const getResellerStatusFilterOptions = (t: TFunction) => [
    { label: t('active'), value: RESELLER_STATUS.ACTIVE },
    { label: t('inactive'), value: RESELLER_STATUS.INACTIVE },
    { label: t('suspended'), value: RESELLER_STATUS.SUSPENDED },
]

export const getResellerTierFilterOptions = (t: TFunction) => [
    { label: t('bronze'), value: RESELLER_TIERS.BRONZE },
    { label: t('silver'), value: RESELLER_TIERS.SILVER },
    { label: t('gold'), value: RESELLER_TIERS.GOLD },
    { label: t('platinum'), value: RESELLER_TIERS.PLATINUM },
]

export const getStatusColor = (status: string): Color => {
    switch (status) {
        case RESELLER_STATUS.ACTIVE:
            return 'success'
        case RESELLER_STATUS.INACTIVE:
            return 'default'
        case RESELLER_STATUS.SUSPENDED:
            return 'error'
        default:
            return 'default'
    }
}

export const getTierColor = (tier: string): Color => {
    switch (tier) {
        case RESELLER_TIERS.BRONZE:
            return 'default'
        case RESELLER_TIERS.SILVER:
            return 'secondary'
        case RESELLER_TIERS.GOLD:
            return 'warning'
        case RESELLER_TIERS.PLATINUM:
            return 'info'
        default:
            return 'default'
    }
}
